/* eslint-disable */
import {
  axios,
  config
} from '../api'
import store from '../store'

let pay = {}

pay.getEditDto = (_ID) => {
  return axios('post', config.API_URL + '/api/Pay/GetEditDto',{}, {
    ID: _ID //租户ID
  })
}

pay.add = {
  data: {
    FileList: [],
    ContractID: '', // 合同编号
    IsInvoice: '', // 是否开票，是或否
    Money: 0,
    TaxRate:0,
    PayWayType:'',
    NormalType:'',
    ShouTuiType:'',
    XiaoXiang:'',
    MoneyDate:'',
    PaperDate:'',
    Agent:'',
    Notes:'',
  },
  post(_data) {
    _data = _data ? _data : this.data
    return axios('post', config.API_URL + '/api/Pay/Add', _data)
  }
}

pay.edit = {
  data: {
    FileList: [],
    ContractID: '', // 合同编号
    IsInvoice: '是', // 是否开票，是或否
    Money: 0,
    TaxRate:0,
    PayWayType:'',
    NormalType:'',
    ShouTuiType:'',
    XiaoXiang:'',
    MoneyDate:'',
    PaperDate:'',
    Agent:'',
    Notes:'',
  },
  post(_data) {
    _data = _data ? _data : this.data
    return axios('post', config.API_URL + '/api/Pay/Edit', _data)
  }
}

pay.del = (_ID) => {
  return axios('post', config.API_URL + '/api/Pay/Del',{}, {
    idList: _ID
  })
}

pay.getList = {
  data: {
    PageIndex: 1,
    PageSize: 10,
    CondList: [
      {
        Key: "",
        Operator: "",
        Value: ""
      }
    ]
  },
  post(_data) {
    _data = _data ? _data : this.data
    return axios('post', config.API_URL + '/api/Pay/GetList', _data)
  }
}

export default pay



